import en from "./en";
import ja from "./ja";

const common = {
  en,
  ja
};
export default common;